























































import Vue from 'vue';
import Component from 'vue-class-component';

import ResumeListComponent from '@/modules/invoicing/components/ResumeListComponent.vue';
import { Prop, PropSync } from 'vue-property-decorator';
import { getDate } from '@/modules/shared/shared/domain/functions/date-functions';
import { maintenanceReports } from '@/modules/shared/shared/store/namespaces';
import { MAINTENANCE_REPORTS_FETCH_BY_DC } from '@/modules/reports/maintenance-reports/store/maintenance-reports.actions';

@Component({
    components: { ResumeListComponent },
})
export default class ListView extends Vue {
    searchFilter: string | null = null;

    ctdc: boolean = true;

    snackbarError: boolean = false;

    @Prop({ type: String, required: true })
    type?: string;
    @Prop({ type: Function, required: true })
    repositoryFunction?: Function;
    @Prop({ type: Array, required: true })
    data?: { id: number; date: Date; name: string }[];
    @PropSync('isLoading', { type: Boolean, required: true })
    loading?: boolean;

    async changeDatacenter(isCtdc: boolean) {
        this.loading = true;
        this.ctdc = isCtdc;
        await this.MAINTENANCE_REPORTS_FETCH_ALL(this.locationName);
        this.loading = false;
    }

    get filteredData() {
        let r = this.data;
        if (r) {
            if (this.searchFilter) {
                r = r.filter(i => getDate(`${i.date}`).includes(this.searchFilter!.toLowerCase()));
            }
        }

        return r;
    }

    async openFile({ fileName, done }) {
        this.snackbarError = false;
        let newWindow: any = window.self;

        try {
            if (this.repositoryFunction) {
                const response = await this.repositoryFunction(fileName, this.locationName);
                const file = new Blob([response.data], {
                    type: 'application/pdf',
                });
                const fileURL = URL.createObjectURL(file);
                newWindow.open(fileURL);
            } else {
                this.snackbarError = true;
            }
        } catch (ex) {
            this.snackbarError = true;
        }

        done();
    }

    get locationName(): string {
        return this.ctdc ? 'CARACAS' : 'VALENCIA';
    }

    @maintenanceReports.Action(MAINTENANCE_REPORTS_FETCH_BY_DC)
    MAINTENANCE_REPORTS_FETCH_ALL!: (location: string) => Promise<boolean>;
}
